'use client'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Colors, Typography } from '@b-stock/fe-core/design-system'

import Image from '@/components/Image'

import { LINKS } from './content'
import { Inner, Section, TextLink } from './ui'

const StoryInner = styled(Inner)`
  gap: 2rem;

  @media ${Breakpoints.min.large} {
    flex-direction: row;
    align-items: center;
    gap: 4rem;
  }
`

const Visual = styled(Image)`
  display: block;
  width: 100%;
  height: auto;
  min-width: 0;
  aspect-ratio: 1400 / 702;
  border-radius: 0.5rem;

  @media ${Breakpoints.min.large} {
    flex: 0 0 43%;
  }
`

const Copy = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: 1rem;
`

const Eyebrow = styled.p`
  ${Typography.Subtitle2};
  margin: 0;
  color: ${Colors.Semantic.BStock.onhover};
  text-transform: uppercase;
  letter-spacing: 0.07rem;
`

const Quote = styled.blockquote`
  ${Typography.Title3};
  margin: 0;
  color: ${Colors.Semantic.Neutral.light_black};

  &::before {
    content: '\\201C';
  }

  &::after {
    content: '\\201D';
  }
`

const Attribution = styled.p`
  ${Typography.Body1_Semibold};
  margin: 0;
  padding-bottom: 1rem;
  border-bottom: 0.0625rem solid ${Colors.Semantic.Neutral.medium_grey};
  color: ${Colors.Semantic.Neutral.light_black};
`

export default function SuccessStory() {
  return (
    <Section data-testid="logged-out-success-story">
      <StoryInner>
        <Visual
          src="/home-portal/images/loggedOutHomepage/success-story-jim-rowe.webp"
          alt=""
          width={1400}
          height={702}
          sizes="(min-width: 90rem) 578px, (min-width: 64rem) calc(0.43 * (100vw - 6rem)), (min-width: 48rem) calc(100vw - 6rem), calc(100vw - 3rem)"
        />
        <Copy>
          <Eyebrow>
            <FormattedMessage id="LoggedOutHomepage.successStory.eyebrow" />
          </Eyebrow>
          <Quote>
            <FormattedMessage id="LoggedOutHomepage.successStory.quote" />
          </Quote>
          <Attribution>
            <FormattedMessage id="LoggedOutHomepage.successStory.attribution" />
          </Attribution>
          <div>
            <TextLink href={LINKS.jimRoweStory}>
              <FormattedMessage id="LoggedOutHomepage.successStory.readMore" />
              <FontAwesomeIcon icon={faArrowRight} />
            </TextLink>
          </div>
        </Copy>
      </StoryInner>
    </Section>
  )
}
